import MemorialPagesSection from './components/MemorialPagesSection.vue';
import InitLazyComponent from 'Modules/InitLazyComponent';
import store from 'Stores/store';

const section = document.getElementById('memorial-pages-section');
const initLazyComponent = new InitLazyComponent({
  selectors: section,
  components: { MemorialPagesSection },
  template: '<MemorialPagesSection />',
  store,
});

initLazyComponent.init();
